import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { ECSTask } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../magic/MagicTable';

export type ECSTasksTableProps = {
  selectable?: boolean;
  loading?: boolean;
  tasks: ECSTask[];
  onViewTask?: (task: ECSTask) => unknown;
  onSelect?: (names: string[]) => void;
};

type ECSTaskRow = ECSTask & {
  serviceName: string;
};

export const getECSTaskServiceName = ({ group, startedBy }: Partial<ECSTask>): string => {
  const extractServiceName = (value?: string): string =>
    value?.startsWith('service:') ? value.replace('service:', '') : '';

  return extractServiceName(group) || extractServiceName(startedBy);
};

export const ECSTasksTable = ({
  tasks,
  selectable = true,
  loading,
  onViewTask,
  onSelect,
}: ECSTasksTableProps): ReactElement => {
  const rows: ECSTaskRow[] = tasks.map((task) => ({
    ...task,
    serviceName: getECSTaskServiceName(task),
  }));

  return (
    <MagicTable
      schema={getSchema('ECS')}
      entry="Task"
      idAttribute="taskArn"
      rows={rows}
      selectable={selectable}
      onSelect={onSelect}
      order={['serviceName', 'taskArn', 'lastStatus', 'desiredStatus']}
      loading={loading}
      externalFields={{
        serviceName: (row: ECSTaskRow) => <>{row.serviceName || '-'}</>,
        taskArn: (row) => (
          <Link onClick={() => onViewTask && onViewTask(row)} underline="hover">
            {row.taskArn}
          </Link>
        ),
      }}
    />
  );
};
